import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import Loader from './utils/Loadersmall';
import ProductItem from './utils/ProductItem';

class Products extends Component {
    constructor(props) {
        super(props);

        this.state = {
            productsList: [],
            brabcrumb: {},
            serviceCheck: false,
            didYouKnowPage: 0,
        };

        this.goToPreviousDidYouKnowPage = this.goToPreviousDidYouKnowPage.bind(this);
        this.goToNextDidYouKnowPage = this.goToNextDidYouKnowPage.bind(this);
        this.setDidYouKnowPage = this.setDidYouKnowPage.bind(this);
    }

    async componentDidMount() {
        await this.getProducts();
    }

    async componentDidUpdate(prevProps) {
        const currentParams = this.props.match.params;
        const previousParams = prevProps.match.params;

        if (
            currentParams.type !== previousParams.type ||
            currentParams.id !== previousParams.id ||
            currentParams.name !== previousParams.name
        ) {
            await this.getProducts();
        }
    }

    decodeCategoryId(value) {
        try {
            return Buffer.from(value || '', 'base64').toString('ascii');
        } catch (error) {
            return '';
        }
    }

    async getProducts() {
        this.setState({ serviceCheck: false });

        const params = new URLSearchParams();
        params.append('pageType', 'producs');
        params.append('display_type', this.props.match.params.type);
        params.append('finalCategory', this.decodeCategoryId(this.props.match.params.id));
        params.append('display_name', this.props.match.params.name);
        params.append('filter_data', JSON.stringify([]));

        try {
            const response = await axios.post('https://shop.mybadge.co.in/api/apiv1/products', params);
            const resVal = response.data;

            if (resVal.status === 'success') {
                this.setState({
                    productsList: Array.isArray(resVal.data) ? resVal.data : [],
                    brabcrumb: resVal.category || {},
                });
            } else {
                this.setState({
                    productsList: [],
                    brabcrumb: {},
                });
            }
        } catch (error) {
            console.error(error);
            this.setState({
                productsList: [],
                brabcrumb: {},
            });
        } finally {
            this.setState({ serviceCheck: true });
        }
    }

    renderBreadcrumb() {
        const { brabcrumb } = this.state;
        const crumbs = [
            { label: 'Home', to: '/' },
            brabcrumb.main_category ? { label: brabcrumb.main_category, to: '/' } : null,
            brabcrumb.sub_category ? { label: brabcrumb.sub_category, to: '/' } : null,
            brabcrumb.final_category ? { label: brabcrumb.final_category, to: '/' } : null,
        ].filter(Boolean);

        return (
            <ul className="ps-products-page__breadcrumbs">
                {crumbs.map((crumb, index) => {
                    const isLast = index === crumbs.length - 1;
                    return (
                        <li
                            className={`ps-products-page__breadcrumb ${isLast ? 'ps-products-page__breadcrumb--active' : ''}`}
                            key={`${crumb.label}-${index}`}
                        >
                            {isLast ? <span>{crumb.label}</span> : <Link to={crumb.to}>{crumb.label}</Link>}
                        </li>
                    );
                })}
            </ul>
        );
    }

    getDidYouKnowItems() {
        return [
            {
                id: 'sesame-oil-1',
                image: '/assets/img/list/product_1.png',
            },
            {
                id: 'cane-sugar-1',
                image: '/assets/img/list/product_2.png',
            },
            {
                id: 'sesame-oil-2',
                image: '/assets/img/list/product_1.png',
            },
            {
                id: 'cane-sugar-2',
                image: '/assets/img/list/product_2.png',
            },
        ];
    }

    getDidYouKnowPages() {
        const items = this.getDidYouKnowItems();
        const pages = [];

        for (let index = 0; index < items.length; index += 2) {
            pages.push(items.slice(index, index + 2));
        }

        return pages;
    }

    setDidYouKnowPage(pageIndex) {
        const pages = this.getDidYouKnowPages();
        if (pages.length === 0) {
            return;
        }

        const nextPage = Math.max(0, Math.min(pageIndex, pages.length - 1));
        this.setState({ didYouKnowPage: nextPage });
    }

    goToPreviousDidYouKnowPage() {
        const pages = this.getDidYouKnowPages();
        if (pages.length === 0) {
            return;
        }

        this.setState((prevState) => ({
            didYouKnowPage: (prevState.didYouKnowPage - 1 + pages.length) % pages.length,
        }));
    }

    goToNextDidYouKnowPage() {
        const pages = this.getDidYouKnowPages();
        if (pages.length === 0) {
            return;
        }

        this.setState((prevState) => ({
            didYouKnowPage: (prevState.didYouKnowPage + 1) % pages.length,
        }));
    }

    render() {
        if (this.state.serviceCheck === false) {
            return <Loader />;
        }

        const { productsList } = this.state;
        const productCount = productsList.length;
        const didYouKnowPages = this.getDidYouKnowPages();
        return (
            <div className="ps-products-page">
                <section className="ps-products-page__hero">
                    <div className="container">
                        {this.renderBreadcrumb()}
                        <div className="ps-products-page__hero-grid">
                            <div className="ps-products-page__hero-copy">
                            </div>

                            <div className="ps-products-page__hero-visual" aria-hidden="true">
                                <div className="ps-products-page__hero-visualInner">
                                    <img
                                        src="/assets/img/list/banner.png"
                                        alt=""
                                        className="ps-products-page__hero-image"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="ps-products-page__catalog">
                    <div className="container">
                        <div className="ps-products-page__catalog-head">
                            <div>
                                <span className="ps-products-page__catalog-eyebrow">Explore products</span>
                                <h2 className="ps-products-page__catalog-title">
                                    Curated for a better shopping experience
                                </h2>
                            </div>
                        </div>

                        {productCount > 0 ? (
                            <div className="row g-4 ps-products-page__grid">
                                {productsList.map((productInfo, index) => (
                                    <div
                                        className="col-6 col-md-4 col-xl-3"
                                        key={productInfo.variation_id || productInfo.product_id || index}
                                    >
                                        <ProductItem product_details={productInfo} />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="ps-products-page__empty">
                                <div className="ps-products-page__emptyCard">
                                    <span className="ps-products-page__emptyEyebrow">No results</span>
                                    <h3>We could not find any products in this collection yet.</h3>
                                    <p>Please check back soon or browse another category from the homepage.</p>
                                    <Link to="/" className="ps-products-page__emptyButton">
                                        Back to Home
                                    </Link>
                                </div>
                            </div>
                        )}
                    </div>
                </section>

                <section className="ps-products-page__knowledge" aria-label="Did you know image slider">
                    <div className="container-fluid">
                        <div className="ps-products-page__knowledgeCarousel">
                            <button
                                type="button"
                                className="ps-products-page__knowledgeNav ps-products-page__knowledgeNav--prev"
                                onClick={this.goToPreviousDidYouKnowPage}
                                aria-label="Previous images"
                            >
                                <i className="fa fa-angle-left" />
                            </button>

                            <div className="ps-products-page__knowledgeViewport">
                                <div
                                    className="ps-products-page__knowledgeTrack"
                                    style={{transform: `translateX(-${this.state.didYouKnowPage * 100}%)`}}
                                >
                                    {didYouKnowPages.map((page, pageIndex) => (
                                        <div className="ps-products-page__knowledgePage" key={`did-you-know-page-${pageIndex}`}>
                                            {page.map((item) => (
                                                <div className="ps-products-page__knowledgeCard" key={item.id}>
                                                    <img src={item.image} alt="" className="ps-products-page__knowledgeImage" aria-hidden="true" loading="lazy" />
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <button
                                type="button"
                                className="ps-products-page__knowledgeNav ps-products-page__knowledgeNav--next"
                                onClick={this.goToNextDidYouKnowPage}
                                aria-label="Next images"
                            >
                                <i className="fa fa-angle-right" />
                            </button>
                        </div>

                        <div className="ps-products-page__knowledgeDots" role="tablist" aria-label="Image slider navigation">
                            {didYouKnowPages.map((_, index) => (
                                <button
                                    type="button"
                                    key={`did-you-know-dot-${index}`}
                                    className={`ps-products-page__knowledgeDot ${this.state.didYouKnowPage === index ? 'ps-products-page__knowledgeDot--active' : ''}`}
                                    onClick={() => this.setDidYouKnowPage(index)}
                                    aria-label={`Show image page ${index + 1}`}
                                    aria-pressed={this.state.didYouKnowPage === index}
                                />
                            ))}
                        </div>
                    </div>
                </section>

                <section className="ps-products-page__banner" aria-label="Products banner">
                    <img
                        src="/assets/img/list/product_banner.png"
                        alt="Products banner"
                        className="ps-products-page__bannerImage"
                        style={{ width: '100%', display: 'block', height: 'auto' }}
                    />
                </section>
            </div>
        );
    }
}

export default Products;
